import { BUTTON_TYPES } from '@src/quince-components/src'
import Button from '@src/quince-site-common/src/domains/Button'

import * as styles from './newLongFormModuleCTA.module.scss'

export const makeButtonProps = (button: Button | null | undefined) => {
  if (button) {
    const buttonProps = Button.makeButtonProps({
      ...button,
      type: BUTTON_TYPES.SECONDARY_LINK,
      classNames: [styles.btnLongForm],
    })
    return buttonProps
  }
}
